import React from "react"
import BaseSvgIcon from "../Base"

const Scissors = ({stroke = "#21295C", strokeWidth = 6.66667, width = 107, height = 106, ...props}) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 107 106" width={width} height={height} fill="none">
      <path
        d="M80.1667 26.2533L41.8333 64.5866M41.8333 41.2533L80.1667 79.5866M71.8333 52.9199H71.8667M86.8333 52.9199H86.8667M33.5 22.9199C39.0228 22.9199 43.5 27.3971 43.5 32.9199C43.5 38.4428 39.0228 42.9199 33.5 42.9199C27.9772 42.9199 23.5 38.4428 23.5 32.9199C23.5 27.3971 27.9772 22.9199 33.5 22.9199ZM33.5 62.9199C39.0228 62.9199 43.5 67.3971 43.5 72.9199C43.5 78.4428 39.0228 82.9199 33.5 82.9199C27.9772 82.9199 23.5 78.4428 23.5 72.9199C23.5 67.3971 27.9772 62.9199 33.5 62.9199Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseSvgIcon>
  )
}

export default Scissors
